import { Link as RouterLink } from 'react-router-dom';
import Logo from './Logo';

// Responsive pass (2026-10-29): the default logo (55.6px) made the fixed header ~96px tall,
// so it is shrunk to 32px below md (56px header; the link keeps a 44px tap height). On a phone in landscape (≤500px tall) the
// header stops being fixed and the spacer goes, so it scrolls away instead of covering the form.
const SHORT_VIEWPORT_STATIC = '[@media(max-height:500px)]:static';

// `z-100`, the package's own SiteShell header level (pending audit 2026-10-30, WEB-4): above the
// page, below the package's Popover/Lightbox (`z-200`) and Modal/Menu/Toast (`z-1300`). The old
// `z-[1201]` was MUI's `zIndex.drawer + 1` from the template, and it covered the DatePicker's
// calendar on the first wizard step.
export default function Header() {
  return (
    <>
      <header className={`fixed inset-x-0 top-0 z-100 w-full bg-surface ${SHORT_VIEWPORT_STATIC}`}>
        <div className="mx-auto max-w-[1536px] px-4 min-[600px]:px-6">
          <div className="flex min-h-14 items-center py-1.5 md:py-5">
            <RouterLink to="/" className="flex min-h-11 grow items-center no-underline">
              <div className="flex items-center max-md:[&_svg]:h-8 max-md:[&_svg]:w-auto">
                <Logo />
              </div>
            </RouterLink>
          </div>
        </div>
      </header>

      {/* Spacer for the fixed header: 56px below md, 96px (py-5 + the 55.6px logo) from md up */}
      <div className="h-14 md:h-24 [@media(max-height:500px)]:hidden" />
    </>
  );
}
